<template>
	<div class="home-wrap">
		<div class="content">
			<div>
				<div style="height: .4rem"></div>
				<div class="banner">
					<div class="swiper-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide">1111</div>
							<div class="swiper-slide">2222</div>
							<div class="swiper-slide">3333</div>
							<div class="swiper-slide">4444</div>
						</div>
						<!-- 如果需要分页器 -->
						<div class="swiper-pagination"></div>
					</div>
				</div>
				<div class="package-sorting">
					<ul>
						<li>
							<img src="" alt="">
							<p @touchstart="goPpayment(1)"><b>青年版 (17-44周岁)</b></p>
						</li>
						<li>
							<img src="" alt="">
							<p @touchstart="goPpayment(2)"><b>中年版 (45-60周岁)</b></p>
						</li>
						<li>
							<img src="" alt="">
							<p @touchstart="goPpayment(3)"><b>老年版 (60周岁以上)</b></p>
						</li>
					</ul>
				</div>
				<div style="height: .59rem"></div>
			</div>
		</div>
		<myheader></myheader>
	</div>
</template>
<script>
 import myheader from '@/phonecomponents/pheader'
 const components = {
 	myheader
 }
export default {
	components:components,
	data() {
		return {
			mySwiper: null,
			myIScroll: null,
			
		}
	},
	mounted(){
		var _this = this;
		
		setTimeout(function(){
			
			_this.mySwiper = new Swiper('.swiper-container',{
					direction: 'horizontal',
				    autoplay: 2400,
					loop: true,
					// 如果需要分页器
				    pagination: '.swiper-pagination',
			})
			_this.myIScroll = new IScroll(".content", {
				scrollY: true,
				scrollX: false,
				probeType: 3,
				preventDefault: false,
				bindToWrapper: true,
				"onScrollMove": function(){return false},
				"onScrollEnd": function(){return false}
			})
		},200)
	},
	methods: {
		goPpayment(ind){
			this.$router.replace({path:'/ppayment',query: {id: ind}})
		}
	},
	updated(){
		this.myIScroll.refresh();
	}
}
</script>
<style lang="scss">
	@import "../styles/common/swiper-3.4.2.min.css";
	.home-wrap{
		width: 100%;
		height: 100%;
			.content{
				width: 100%;
				height: 100%;
			.banner{
				height: 1.45rem;
				background: #fff;
				.swiper-container{
					width: 100%;
					height: 100%;
					.swiper-wrapper{
						width: 100%;
						height: 100%;
						font-size: .14rem;
						.swiper-slide{
							width: 100%;
							height: 100%;
						}
					}
					.swiper-pagination{
						bottom: -.3rem;
						span{
							width: .3rem;
							height: .03rem;
							background: none;
							border: 1px solid #000;
							border-radius: 0.02rem;
							&.swiper-pagination-bullet-active{
								border: 1px solid #467DE5;
							}
						}
					}
				}
			}
			.package-sorting{
				width: 100%;
				ul{
					width: 100%;
					li{
						width: 100%;
						height: 2.11rem;
						margin-top: .1rem;
						background: #eee;
						position: relative;
						p{
							width: 100%;
							height: .44rem;
							background: #fff;
							position: absolute;
							bottom: 0;
							left: 0;
							font-size: .18rem;
							text-align: center;
							line-height: .44rem;
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// home.vue?1ccce7b1